var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 'cover' && _vm.subType === 'flexible')?_c('Cover',{attrs:{"section":_vm.section}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }